import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { brandName, heroBadges, heroImage, stats } from '../data/copy';
import { HERO_QUALITY, HERO_SIZES, HERO_SRC_WIDTH, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-135" data-mp="4n9wadwh9812">
      {/* Mobile: promise → mockup → details. Desktop: copy left, mockup right. */}
      <div className="mx-auto grid max-w-6xl gap-x-12 px-6 pb-8 pt-6 sm:pt-10 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:pb-12 lg:pt-12" data-id="element-136" data-mp="1274p5sdm9m8t">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" style={{
        width: "321px",
        height: "117px"
      }} data-id="element-137" data-mp="sai2qz5n6n4o">
          <Pill tone="accent" data-id="element-138" data-mp="nbyh6zuyndcu">For volleyball coaches</Pill>

          <h1 className="mt-5 font-display text-[2.6rem] font-extrabold uppercase leading-[0.92] text-fg sm:text-6xl lg:text-[4.4rem]" style={{
          fontSize: "32px"
        }} data-id="element-139" data-mp="3d1sbczku5nu6">
            Plan your next volleyball practice in{' '}
            <span className="text-accent" data-id="element-140" data-mp="3j925rpk1dsw2">5 minutes</span>
          </h1>

          
        </div>

        <div className="relative mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-141" data-mp="3o73mw4xwji4w">
          <div className="absolute inset-x-0 bottom-6 top-10 rounded-[2rem] bg-panel ring-1 ring-line" aria-hidden="true" data-id="element-142" data-mp="399jo5frlmj76" />
          <img src={optimizedImage(heroImage, HERO_SRC_WIDTH, HERO_QUALITY)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS, HERO_QUALITY)} sizes={HERO_SIZES} alt="VOLLEYBALL 360 READY™ complete: 6 visual coaching volumes, a practice-plan tablet view, and 5 practical coaching bonuses." className="relative mx-auto w-full max-w-md sm:max-w-xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} style={{
          width: "314px",
          height: "307px"
        }} data-id="element-143" data-mp="3ebirwqr93i4n" />
        </div>

        <div className="mt-6 text-center lg:col-start-1 lg:row-start-2 lg:mt-6 lg:self-start lg:text-left" data-id="element-144" data-mp="2hjymv1586qlk">
          <p className="mx-auto max-w-xl leading-relaxed text-muted lg:mx-0" style={{
          fontSize: "12px"
        }} data-id="element-145" data-mp="2lmuyg7wclmg0">
            The complete digital PDF system for volleyball coaches: step-by-step
            technique, illustrated drills, progressions, court diagrams, common
            mistakes, quick fixes, decision-making exercises, and complete
            practices already organized for you.
          </p>

          <div className="mt-7" data-id="element-146" data-mp="1b0nkju104b5h">
            <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-147" data-mp="1azui3592s7t5">
              Get full access now
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-148" data-mp="112pwp7n20gde">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-sm text-muted" data-id="element-149" data-mp="x1nwoolbc0ad">
                <CheckIcon className="h-4 w-4 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-150" data-mp="3lsp3hdsd4jef" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-y border-line bg-navy" data-id="element-151" data-mp="3htpy5s2pykmg">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-2 sm:px-6" data-id="element-152" data-mp="1xam72v6j3z11">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-7 text-center" data-id="element-153" data-mp="21bft1j0ev3ra">
              <dt className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted sm:text-sm" data-id="element-154" data-mp="2697ouo46fa0r">
                {stat.label}
              </dt>
              <dd className="font-display text-5xl font-extrabold leading-none text-accent sm:text-6xl" data-id="element-155" data-mp="2g0c3fmpxwsv2">
                {stat.value}
              </dd>
            </div>)}
        </dl>
        <p className="border-t border-line bg-accent py-3 text-center font-display text-sm font-bold uppercase tracking-[0.4em] text-on-accent" data-id="element-156" data-mp="2p0qn6hn99zwg">
          Courtside ready
        </p>
      </div>
    </header>;
}